import React, { memo } from "react"
import { FlexContainer } from "heliocor-ui"

import { DocumentDetails } from "./DocumentDetails/DocumentDetails"
import { DocumentDetailsWithUpdate } from "./DocumentDetails/DocumentDetailsWithUpdate"

const DOC_VIEWER_TYPES = {
    DOCS_DETAILS: "DOCS_DETAILS",
    DOC_DETAILS_WITH_UPDATE: "DOC_DETAILS_WITH_UPDATE",
}

const DocumentViewer = ({
    document,
    documentConfig,
    deleteDocument,
    canUpload,
    canDelete = true,
    handleUpload,
    deleteIndividualDocument,
    sendForManualValidation,
    owner
}) => {
    const viewerType = documentConfig.core
        ? DOC_VIEWER_TYPES.DOCS_DETAILS
        : DOC_VIEWER_TYPES.DOC_DETAILS_WITH_UPDATE

    return (
        <FlexContainer column data-cy="documentDetails">
            {viewerType === DOC_VIEWER_TYPES.DOCS_DETAILS && (
                <DocumentDetails
                    document={document}
                    canDelete={canDelete}
                    deleteDocument={deleteDocument}
                    sendForManualValidation={sendForManualValidation}
                    owner={owner}
                />
            )}
            {viewerType === DOC_VIEWER_TYPES.DOC_DETAILS_WITH_UPDATE && (
                <DocumentDetailsWithUpdate
                    document={document}
                    documentConfig={documentConfig}
                    deleteIndividualDocument={deleteIndividualDocument}
                    deleteDocument={deleteDocument}
                    canDelete={canDelete}
                    handleUpload={handleUpload}
                    canUpload={canUpload}
                />
            )}
        </FlexContainer>
    )
}

export default memo(DocumentViewer)
